import { depositFor, isPhotoDeposit } from '../lib/depositTerms';

export const OfferDeposit = ({ offer, id, className = 'text-xs mt-3' }) => {
  if (!isPhotoDeposit(offer) && offer.slug !== 'mini-noel-2026') return null;
  return <p className={className} data-testid={id}>
    {offer.requires_quote && !offer.fixed_price ? `Acompte : ${offer.deposit_pct} % du devis` : `${offer.deposit_pct === 100 ? 'Paiement intégral' : 'Acompte'} : CHF ${depositFor(offer).toLocaleString('fr-CH')}`}
  </p>;
};